import { HostListener, ViewChild, Injectable} from '@angular/core';
import { NgForm } from '@angular/forms';

@Injectable()
export abstract class CanDeactivateComponent {
    @ViewChild('ngFormDirtyCheck')
    private _ngFormDirtyCheck: NgForm;
    public selectedPage: any;
    public targetPage: any;
    public componentName: string;

    public get ngFormDirtyCheck(): NgForm {
        return this._ngFormDirtyCheck;
    }

    public set ngFormDirtyCheck(value: NgForm) {
        this._ngFormDirtyCheck = value;
    }

    abstract canDeactivate(): boolean;
    @HostListener('window:beforeunload', ['$event'])

    unloadNotification($event: any) {
        if (!this.canDeactivate()) {
            $event.returnValue = true;
        }
    }
}
